__turbopack_context__.v({
  "assistant": "aJDexG_assistant",
  "attachment": "aJDexG_attachment",
  "trigger": "aJDexG_trigger",
  "user": "aJDexG_user",
});
